<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <a class="navbar-item" :href="title_link">{{ title_url }}</a>
      <!-- Hamburger icon -->
      <a
        role="button"
        class="navbar-burger"
        :class="{ 'is-active': isNavActive }"
        @click="toggleNav"
        aria-label="menu"
        aria-expanded="false"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div class="navbar-menu" :class="{ 'is-active': isNavActive }">
      <div class="navbar-start">
        <div class="navbar-item">
          <router-link :to="schedule_url">Schedule</router-link>
        </div>
        <div class="navbar-item">
          <router-link :to="thumbs_url">Thumbnails</router-link>
        </div>
      </div>
      <div class="navbar-end">
        <div class="navbar-item" v-for="ayear in years" :key="ayear">
          <router-link :to="schedule_url_for(ayear)">{{ ayear }}</router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["year"],
  data() {
    return {
      isNavActive: false
    };
  },
  methods: {
    toggleNav() {
      this.isNavActive = !this.isNavActive;
    },
    schedule_url_for(ayear) {
      return "/schedule/" + ayear;
    }
  },
  computed: {
    ...mapGetters(["years"]),
    title_url() {
      return "FAB Academy " + this.year + " - Final Projects";
    },
    title_link() {
      return "https://fabacademy.org/" + this.year;
    },
    schedule_url() {
      return "/schedule/" + this.year;
    },

    thumbs_url() {
      return "/thumbnails/" + this.year;
    }
  }
};
</script>

<style>
nav.navbar {
}
.navbar-brand .navbar-item {
  font-weight: bold;
}
</style>
